import React, { useMemo } from 'react';

import * as Yup from 'yup';
import { useQuery, useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import CrudForm from '../../Form/CrudForm';
import CrudPageLayout from '../../../layouts/CrudPageLayout';

import { LOAN_FILE_STATUSES } from '../../../constants/formOptions';
import { USER_ROLES } from '../../../constants/main';
import LoanFileService from '../../../services/LoanFileService';
import BrokerTeamService from '../../../services/BrokerTeamService';
import UserService from '../../../services/UserService';

export default function Details({ loanFile, updateLoanFile, isEdit }) {
  const navigate = useNavigate();

  const { data: brokerTeams } = useQuery({
    queryKey: ['brokerTeams', loanFile?.brokerId],
    queryFn: () =>
      BrokerTeamService.getBrokerTeams({
        brokerIds: [loanFile?.brokerId],
      }),
    enabled: !!loanFile,
  });

  const { data: users } = useQuery({
    queryKey: ['loanOfficers', loanFile?.brokerId],
    queryFn: () =>
      UserService.getUsers({
        id: [loanFile?.brokerId],
        role: USER_ROLES.loanOfficer,
      }),
    enabled: !!loanFile,
  });

  const { mutate: createLoanFile } = useMutation({
    mutationFn: (formValues) => LoanFileService.createLoanFile(formValues),
    onSuccess: (loanFile) => {
      navigate(`/loan-files/${loanFile.id}/borrowers`);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const fields = useMemo(
    () => [
      {
        label: 'Number',
        placeholder: 'Type number',
        name: 'number',
        type: 'text',
        validation: Yup.string().required('This field is required'),
      },
      {
        label: 'Status',
        placeholder: 'Select status',
        name: 'status',
        type: 'select',
        options: LOAN_FILE_STATUSES,
        validation: Yup.string().required('This field is required'),
      },
      {
        label: 'Loan Officer',
        placeholder: 'Select loan officer',
        name: 'loanOfficerId',
        type: 'select',
        options: users?.map((user) => ({ label: user.name, value: user.id })),
        validation: Yup.string(),
      },
      {
        label: 'Team',
        placeholder: 'Select team',
        name: 'teamId',
        type: 'select',
        options: brokerTeams?.map((team) => ({
          label: team.name,
          value: team.id,
        })),
        validation: Yup.string(),
      },
    ],
    [brokerTeams, users]
  );

  return (
    <CrudPageLayout title={isEdit ? 'Edit Loan File' : 'Add Loan File'}>
      <CrudForm
        fields={fields}
        submitButtonLabel={isEdit ? 'Update' : 'Create'}
        createHandler={createLoanFile}
        updateHandler={updateLoanFile}
        data={loanFile}
      />
    </CrudPageLayout>
  );
}
